var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOdontologo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.895,
    height: 26.631,
    viewBox: "0 0 23.895 26.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Odont\\xF3logo",
    transform: "translate(-65.545 -8.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1378",
    "data-name": "Trazado 1378",
    d: "M9.955,18.713a5.728,5.728,0,1,0-2.436-5.88l-.105.877.431,2.432A5.727,5.727,0,0,0,9.955,18.713ZM11.369,11.3A3.182,3.182,0,1,1,10.2,12.733,3.182,3.182,0,0,1,11.369,11.3ZM3.55,32.8A7,7,0,0,0,8.5,34.85h9.893c.149,0,.368.01.516,0a.756.756,0,0,0,.147,0c3.52-.474,4.462-2.187,4.737-2.546a7,7,0,0,0-5.4-11.456H8.5A7,7,0,0,0,3.55,32.8Zm1.8-8.1a4.456,4.456,0,0,1,3.15-1.3h9.893a4.455,4.455,0,1,1,0,8.91H8.5A4.455,4.455,0,0,1,5.351,24.7Z",
    transform: "translate(64.045 0.062)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdontologo);
export default __webpack_public_path__ + "static/media/Odontologo.27cf4fc7f364fa3d9b3decd244f5fc12.svg";
export { ForwardRef as ReactComponent };